import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function SolutionSection() {
  return <Section background="brown" className="relative overflow-hidden" data-id="element-70">
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-71">
        <div className="absolute top-10 left-10 w-64 h-64 bg-[#C9A227] rounded-full blur-[100px]" data-id="element-72"></div>
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-[#C9A227] rounded-full blur-[100px]" data-id="element-73"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center justify-center p-3 bg-[#C9A227]/20 rounded-full mb-8" data-id="element-75">
          <Sparkles className="w-6 h-6 text-[#C9A227]" data-id="element-76" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-3xl md:text-5xl font-serif text-[#FAF8F5] mb-8" data-id="element-77">
          La respuesta está en la historia
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-[#E0D8D0] leading-relaxed font-light" data-id="element-78">
          Por eso nace{' '}
          <strong className="text-[#C9A227] font-serif" data-id="element-79">
            Genios que Transformaron la Humanidad
          </strong>
          , un pack digital creado para aprender directamente de las mentes que
          cambiaron el rumbo del mundo.
        </motion.p>
      </div>
    </Section>;
}